// @flow
import React from 'react';
import type { Element, ChildrenArray } from 'react';
import { productColor } from './designSystem.js';
import { Language } from './languages.js';

type TextLike =
  | string
  | Element<typeof Language>
  // This supports expression containers containers with textual expressions
  // Eg. <Heading>Objective{plural ? 's' : ''}</Heading>
  | ChildrenArray<string | Element<typeof Language>>;

export function Heading({ children }: {| children: TextLike |}) {
  return (
    <h2
      style={{
        fontWeight: 600,
        color: productColor.cloudburst,
        fontSize: '1.125em',
        lineHeight: 1.33,
        marginTop: '1.77em',
        marginBottom: '0.66em',
      }}
    >
      {children}
    </h2>
  );
}
export function SubHeading({ children }: {| children: TextLike |}) {
  return (
    <h3
      style={{
        fontWeight: 600,
        fontSize: '1em',
        color: productColor.cloudburst,
        lineHeight: 1.375,
        marginTop: '0.375em',
        marginBottom: '0.375em',
      }}
    >
      {children}
    </h3>
  );
}
